import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ProtectedRoute from "@/components/ProtectedRoute";

import ClientLayout from "@/pages/client/ClientLayout";
import ClientRequests from "@/pages/client/ClientRequests";
import NewRequest from "@/pages/client/NewRequest";
import RequestDetail from "@/pages/client/RequestDetail";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminRequests from "@/pages/admin/AdminRequests";
import AdminRequestDetail from "@/pages/admin/AdminRequestDetail";
import AdminSuppliers from "@/pages/admin/AdminSuppliers";
import AdminInbox from "@/pages/admin/AdminInbox";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route
            path="/portal"
            element={
              <ProtectedRoute role="client">
                <ClientLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<ClientRequests />} />
            <Route path="new" element={<NewRequest />} />
            <Route path="requests/:id" element={<RequestDetail />} />
          </Route>

          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="requests" element={<AdminRequests />} />
            <Route path="requests/:id" element={<AdminRequestDetail />} />
            <Route path="suppliers" element={<AdminSuppliers />} />
            <Route path="inbox" element={<AdminInbox />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
